<template>
  <div id="app">
    <header v-if="!login">
      <div class="logo-holder">
        <div class="logo">
          <a href="/Comparateur"><img class="img" src="https://immo-wiin.com/assets/img/logo-2L-immo.jpg" alt="logo"/></a>
        </div>
      </div>
      <nav>
        <ul>
          <li>
            <router-link class="menu-item" to="/Comparateur">
              <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 48.53 25.8">
                <g id="speed" transform="translate(0 -119.904)">
                  <path id="Tracé_26" data-name="Tracé 26" d="M41.448,127.021a24.3,24.3,0,0,0-34.366,0A23.96,23.96,0,0,0,0,144.2v1.474H16.15v-2.947H2.962a21.191,21.191,0,0,1,2.1-7.861l3.627,2.094,1.474-2.552-3.628-2.095a21.527,21.527,0,0,1,5.785-5.8l2.1,3.64,2.553-1.474-2.105-3.646a21.194,21.194,0,0,1,7.922-2.13v4.217h2.947V122.9a21.192,21.192,0,0,1,7.922,2.13l-2.105,3.646,2.553,1.474,2.1-3.64a21.527,21.527,0,0,1,5.785,5.8l-3.628,2.095,1.474,2.553,3.627-2.094a21.193,21.193,0,0,1,2.1,7.861H32.352v2.947l16.178,0v-1.474a23.962,23.962,0,0,0-7.082-17.186Z" transform="translate(0 0)" fill="#22abc5"/>
                  <path id="Tracé_27" data-name="Tracé 27" d="M248.655,258.326l-8.388,9.232-.024,3.427,2.947.021.016-2.3,7.63-8.4Z" transform="translate(-217.472 -125.302)" fill="#22abc5"/>
                </g>
              </svg>
              <span>Comparateur</span>
            </router-link>
          </li>
          <li><router-link class="menu-item" to="/company">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="35.417" viewBox="0 0 35.417 35.417">
              <g id="office" transform="translate(-1.95 -1.95)">
                <path id="Tracé_6" data-name="Tracé 6" d="M37.185,37.317H17.1a.5.5,0,0,1-.5-.5V2.5a.5.5,0,0,1,.5-.5h20.08a.5.5,0,0,1,.5.5V36.813A.5.5,0,0,1,37.185,37.317ZM17.609,36.308H36.68V3.009H17.609Z" transform="translate(-7.234)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_7" data-name="Tracé 7" d="M60.335,42.763H56.9a.5.5,0,0,1-.5-.5V13.5a.5.5,0,0,1,.5-.5h3.431a.5.5,0,0,1,.5.5V42.258A.5.5,0,0,1,60.335,42.763Zm-2.926-1.009h2.422V14H57.409Z" transform="translate(-26.953 -5.446)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_8" data-name="Tracé 8" d="M70.5,45.068a.5.5,0,0,1-.5-.5v-1.5a.5.5,0,0,1,1.009,0v1.5A.5.5,0,0,1,70.5,45.068Z" transform="translate(-33.692 -20.096)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_9" data-name="Tracé 9" d="M67.135,46.241H63.7a.5.5,0,0,1-.5-.5V20.515a.5.5,0,0,1,.5-.5h3.431a.5.5,0,0,1,.5.5V28.36a.5.5,0,1,1-1.009,0V21.019H64.209V45.232h2.422v-3.31a.5.5,0,1,1,1.009,0v3.814A.5.5,0,0,1,67.135,46.241Z" transform="translate(-30.323 -8.923)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_10" data-name="Tracé 10" d="M70.5,55.007a.5.5,0,0,1-.5-.5V53.035a.5.5,0,0,1,1.009,0V54.5A.5.5,0,0,1,70.5,55.007Z" transform="translate(-33.692 -25.036)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_11" data-name="Tracé 11" d="M13.24,42.763H9.3a.5.5,0,0,1-.5-.5V13.5a.5.5,0,0,1,.5-.5H13.24a.5.5,0,0,1,.5.5V42.258A.5.5,0,0,1,13.24,42.763ZM9.809,41.754h2.926V14H9.809Z" transform="translate(-3.369 -5.446)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_12" data-name="Tracé 12" d="M5.935,46.24H2.5a.5.5,0,0,1-.5-.5V20.514a.5.5,0,0,1,.5-.5H5.935a.5.5,0,0,1,.5.5V45.736A.5.5,0,0,1,5.935,46.24ZM3.009,45.231H5.431V21.018H3.009Z" transform="translate(0 -8.923)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_13" data-name="Tracé 13" d="M36.3,12.408H34.108a.734.734,0,0,1-.733-.733V9.482a.734.734,0,0,1,.733-.732H36.3a.734.734,0,0,1,.733.732v2.192a.734.734,0,0,1-.733.735ZM34.383,11.4h1.64V9.759h-1.64Z" transform="translate(-15.545 -3.344)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_14" data-name="Tracé 14" d="M47.8,12.408H45.608a.734.734,0,0,1-.733-.733V9.482a.734.734,0,0,1,.733-.732H47.8a.734.734,0,0,1,.733.732v2.192A.734.734,0,0,1,47.8,12.408ZM45.883,11.4h1.64V9.759h-1.64Z" transform="translate(-21.243 -3.344)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_15" data-name="Tracé 15" d="M24.8,12.408H22.608a.734.734,0,0,1-.733-.733V9.482a.734.734,0,0,1,.733-.732H24.8a.734.734,0,0,1,.733.732v2.192A.734.734,0,0,1,24.8,12.408ZM22.883,11.4h1.64V9.759h-1.64Z" transform="translate(-9.847 -3.344)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_16" data-name="Tracé 16" d="M36.3,25.033H34.108a.734.734,0,0,1-.733-.733V22.108a.734.734,0,0,1,.733-.733H36.3a.734.734,0,0,1,.733.733V24.3a.734.734,0,0,1-.733.733Zm-1.917-1.009h1.64v-1.64h-1.64Z" transform="translate(-15.545 -9.6)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_17" data-name="Tracé 17" d="M47.8,25.033H45.608a.734.734,0,0,1-.733-.733V22.108a.734.734,0,0,1,.733-.733H47.8a.734.734,0,0,1,.733.733V24.3a.734.734,0,0,1-.733.733Zm-1.917-1.009h1.64v-1.64h-1.64Z" transform="translate(-21.243 -9.6)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_18" data-name="Tracé 18" d="M24.8,25.033H22.608a.734.734,0,0,1-.733-.733V22.108a.734.734,0,0,1,.733-.733H24.8a.734.734,0,0,1,.733.733V24.3a.734.734,0,0,1-.733.733Zm-1.917-1.009h1.64v-1.64h-1.64Z" transform="translate(-9.847 -9.6)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_19" data-name="Tracé 19" d="M36.3,37.658H34.108a.734.734,0,0,1-.733-.732V34.733A.734.734,0,0,1,34.108,34H36.3a.734.734,0,0,1,.733.733v2.193A.734.734,0,0,1,36.3,37.658Zm-1.917-1.009h1.64v-1.64h-1.64Z" transform="translate(-15.545 -15.855)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_20" data-name="Tracé 20" d="M47.8,37.658H45.608a.734.734,0,0,1-.733-.732V34.733A.734.734,0,0,1,45.608,34H47.8a.734.734,0,0,1,.733.733v2.193A.734.734,0,0,1,47.8,37.658Zm-1.917-1.009h1.64v-1.64h-1.64Z" transform="translate(-21.243 -15.855)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_21" data-name="Tracé 21" d="M24.8,37.658H22.608a.734.734,0,0,1-.733-.732V34.733A.734.734,0,0,1,22.608,34H24.8a.734.734,0,0,1,.733.733v2.193A.734.734,0,0,1,24.8,37.658Zm-1.917-1.009h1.64v-1.64h-1.64Z" transform="translate(-9.847 -15.855)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
                <path id="Tracé_22" data-name="Tracé 22" d="M36.583,61.75H27.817a.5.5,0,0,1-.5-.5V51.817a.5.5,0,0,1,.5-.5h8.767a.5.5,0,0,1,.5.5v9.429A.5.5,0,0,1,36.583,61.75Zm-8.262-1.009h7.758v-8.42H28.321Z" transform="translate(-12.541 -24.432)" fill="#22abc5" stroke="#22abc5" stroke-width="0.1"/>
              </g>
            </svg>
          <span>Société</span></router-link></li>
          <li v-if="RolesCurrentUser == 'Admin'"><router-link class="menu-item" to="/client">
          <svg id="Icons" height="35" viewBox="0 0 74 74" width="35" xmlns="http://www.w3.org/2000/svg">
            <path d="m19 25.86a1 1 0 0 1 -.035-2 100.408 100.408 0 0 0 14.649-1.24.961.961 0 0 1 .262-.018 7.184 7.184 0 0 1 3.425 1.08 1 1 0 0 1 -.581 1.809 1.029 1.029 0 0 1 -.647-.229 4.99 4.99 0 0 0 -2.205-.653 103.883 103.883 0 0 1 -14.842 1.251z" fill="#22abc5"/>
            <path d="m55.58 49.65a4.032 4.032 0 0 1 -2.375-.77l-.215-.149c-.028-.019-.075-.057-.119-.1l-11.771-8.477a1 1 0 1 1 1.161-1.628l.8.57 11.015 7.943a.943.943 0 0 1 .094.077l.191.133a2.083 2.083 0 0 0 2.841-.393 2.051 2.051 0 0 0 .359-1.856 2.006 2.006 0 0 0 -.665-1.011l-15.744-12.827c-6.029 3.2-10.3 1.554-12.339.251a2.3 2.3 0 0 1 .195-3.969l9.012-4.786a4.919 4.919 0 0 1 3.768-.33l5.331 1.73a6.932 6.932 0 0 0 4.8-.173l2.322-.951a1 1 0 1 1 .759 1.851l-2.32.95a8.916 8.916 0 0 1 -6.182.224l-5.326-1.729a2.9 2.9 0 0 0 -2.219.2l-9.014 4.787a.3.3 0 0 0 -.172.263.274.274 0 0 0 .128.255c2.1 1.342 5.705 2.326 10.866-.639a1 1 0 0 1 1.13.092l16.26 13.25a3.987 3.987 0 0 1 1.328 2 4.083 4.083 0 0 1 -.7 3.645 4.032 4.032 0 0 1 -3.199 1.567z" fill="#22abc5"/>
            <path d="m51.442 54.285a4.077 4.077 0 0 1 -2.365-.753l-10.81-7.67a1 1 0 0 1 1.157-1.631l10.81 7.669a2.1 2.1 0 0 0 2.44-3.414l-10.774-7.765a1 1 0 0 1 1.166-1.621l10.777 7.766a4.1 4.1 0 0 1 -2.4 7.421z" fill="#22abc5"/>
            <path d="m46.775 58.292a3.941 3.941 0 0 1 -2.251-.707l-9.687-6.71a1 1 0 0 1 1.139-1.645l9.687 6.71a1.969 1.969 0 0 0 2.74-.5 1.976 1.976 0 0 0 -.48-2.725l-9.64-6.838a1 1 0 1 1 1.157-1.631l9.64 6.838a3.983 3.983 0 0 1 .969 5.493 3.942 3.942 0 0 1 -2.549 1.65 4 4 0 0 1 -.725.065z" fill="#22abc5"/>
            <path d="m41.061 61.58a4 4 0 0 1 -1.991-.542l-5.377-3.1a1 1 0 0 1 1-1.732l5.376 3.1a2 2 0 0 0 2.7-.716 1.96 1.96 0 0 0 -.587-2.621l-6.87-4.759a1 1 0 0 1 1.139-1.644l6.869 4.758a3.982 3.982 0 0 1 -2.26 7.256z" fill="#22abc5"/>
            <path d="m29.738 60.983a4.02 4.02 0 0 1 -2.656-7.043l2.671-2.34a4.022 4.022 0 0 1 5.676.369 4.022 4.022 0 0 1 -.37 5.676l-2.671 2.345a4.006 4.006 0 0 1 -2.65.993zm2.667-8.383a2.013 2.013 0 0 0 -1.333.5l-2.672 2.343a2.022 2.022 0 1 0 2.667 3.04l2.671-2.345a2.021 2.021 0 0 0 -1.333-3.538z" fill="#22abc5"/>
            <path d="m23.684 58.259c-.089 0-.178 0-.267-.008a4 4 0 0 1 -2.762-1.36 4.036 4.036 0 0 1 .345-5.709l4.462-3.917a4.022 4.022 0 0 1 5.676.369l-.723.693.751-.66a4.021 4.021 0 0 1 -.369 5.676l-4.466 3.917a3.99 3.99 0 0 1 -2.647.999zm4.425-9.994a2.007 2.007 0 0 0 -1.331.5l-4.462 3.917a2.052 2.052 0 0 0 1.231 3.57 2 2 0 0 0 1.465-.5l4.462-3.917a2.022 2.022 0 0 0 .186-2.854l-.029-.033a2.006 2.006 0 0 0 -1.384-.679c-.047-.002-.094-.003-.139-.003z" fill="#22abc5"/>
            <path d="m18.638 54.588c-.088 0-.177 0-.267-.008a4 4 0 0 1 -2.762-1.36l-.109-.13a4.022 4.022 0 0 1 .371-5.674l5.173-4.541a4.021 4.021 0 0 1 5.676.369l.113.129a4.021 4.021 0 0 1 -.371 5.674l-5.173 4.541a3.992 3.992 0 0 1 -2.651 1zm5.053-10.712a2.008 2.008 0 0 0 -1.331.5l-5.173 4.541a2.024 2.024 0 0 0 -.187 2.856l.113.129a2.023 2.023 0 0 0 2.853.184l5.173-4.541a2.022 2.022 0 0 0 .186-2.854l-.111-.127a2.007 2.007 0 0 0 -1.387-.682c-.047-.004-.091-.006-.136-.006z" fill="#22abc5"/>
            <path d="m14.291 50.137c-.088 0-.178 0-.267-.009a4.048 4.048 0 0 1 -2.424-7.075l3.239-2.843a4.021 4.021 0 0 1 5.676.369l.035.04a4.021 4.021 0 0 1 -.369 5.676l-3.239 2.843a3.991 3.991 0 0 1 -2.651.999zm3.2-8.927a2.008 2.008 0 0 0 -1.331.5l-3.239 2.843a2.022 2.022 0 0 0 -.186 2.854 2.036 2.036 0 0 0 2.888.226l3.239-2.843a2.022 2.022 0 0 0 .186-2.854l-.035-.04a2.007 2.007 0 0 0 -1.388-.683c-.049-.001-.094-.003-.139-.003z" fill="#22abc5"/>
            <path d="m12.477 44.612a.994.994 0 0 1 -.6-.2l-3.417-2.6a1 1 0 0 1 1.211-1.592l3.417 2.6a1 1 0 0 1 -.606 1.8z" fill="#22abc5"/>
            <path d="m58.519 45.72a1 1 0 0 1 -.707-1.707l5.611-5.613a1 1 0 0 1 1.414 1.414l-5.611 5.611a1 1 0 0 1 -.707.295z" fill="#22abc5"/>
            <path d="m66.17 43.645a1 1 0 0 1 -.853-.476l-12.21-19.86a1 1 0 0 1 .24-1.314l12.093-9.366a1 1 0 0 1 1.587.567l5.947 25.947a1 1 0 0 1 -.485 1.1l-5.831 3.277a.994.994 0 0 1 -.488.125zm-10.889-20.62 11.236 18.275 4.341-2.44-5.43-23.692z" fill="#22abc5"/>
            <path d="m7.83 44a1 1 0 0 1 -.489-.128l-5.831-3.272a1 1 0 0 1 -.485-1.1l5.948-25.944a1 1 0 0 1 1.587-.567l12.094 9.365a1 1 0 0 1 .24 1.314l-12.211 19.86a1 1 0 0 1 -.853.472zm-4.688-4.778 4.341 2.439 11.236-18.276-10.147-7.857z" fill="#22abc5"/>
          </svg>
          <span>Clients</span></router-link></li>
          <li><router-link class="menu-item" to="/searchAlert">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="35.106" viewBox="0 0 29.256 35.106">
            <g id="notification" transform="translate(-42.657)">
              <g id="Groupe_5" data-name="Groupe 5" transform="translate(42.657 5.12)">
                <g id="Groupe_4" data-name="Groupe 4" transform="translate(0)">
                  <path id="Tracé_23" data-name="Tracé 23" d="M71.809,99.158,69.3,94.971a12.444,12.444,0,0,1-1.771-6.4V84.906a10.239,10.239,0,1,0-20.478,0v3.667a12.444,12.444,0,0,1-1.771,6.4l-2.513,4.186a.731.731,0,0,0,.628,1.107H71.181a.731.731,0,0,0,.628-1.107ZM44.681,98.8l1.847-3.079a13.894,13.894,0,0,0,1.981-7.15V84.906a8.776,8.776,0,0,1,17.553,0v3.667a13.906,13.906,0,0,0,1.979,7.15L69.89,98.8Z" transform="translate(-42.657 -74.667)" fill="#22abc5"/>
                </g>
              </g>
              <g id="Groupe_7" data-name="Groupe 7" transform="translate(54.36)">
                <g id="Groupe_6" data-name="Groupe 6" transform="translate(0)">
                  <path id="Tracé_24" data-name="Tracé 24" d="M216.258,0a2.928,2.928,0,0,0-2.925,2.925V5.851a.731.731,0,0,0,1.463,0V2.925a1.463,1.463,0,0,1,2.925,0V5.851a.731.731,0,0,0,1.463,0V2.925A2.928,2.928,0,0,0,216.258,0Z" transform="translate(-213.333)" fill="#22abc5"/>
                </g>
              </g>
              <g id="Groupe_9" data-name="Groupe 9" transform="translate(53.628 29.256)">
                <g id="Groupe_8" data-name="Groupe 8" transform="translate(0)">
                  <path id="Tracé_25" data-name="Tracé 25" d="M209.488,427.04a.732.732,0,0,0-1.264.74,2.194,2.194,0,1,1-3.8,0,.732.732,0,0,0-1.264-.74,3.658,3.658,0,1,0,6.328,0Z" transform="translate(-202.666 -426.68)" fill="#22abc5"/>
                </g>
              </g>
            </g>
          </svg>

          <span> Alertes</span></router-link></li>
          <li v-if="RolesCurrentUser == 'Admin'"><router-link class="menu-item" to="/users">
          
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  width="35" height="35"
              viewBox="0 0 397.4 256.5" style="enable-background:new 0 0 397.4 256.5;" xml:space="preserve">
            <g id="Layer_2_1_">
              <g id="Capa_1">
                <g id="Tracé_2178">
                  <path d="M397.4,256.5H281.7v-48.9c-0.7-23.1-12.8-44.3-32.4-56.6l-12.6-7.9l14.8-1.3c7-0.6,12.7-0.9,17.5-0.9
                    c18.2,0,49.8,4.1,78.9,15.8c32.3,12.9,49.4,30.5,49.4,50.8V256.5z M291.7,246.5h95.6v-39c0-21.2-27-35.1-43.1-41.6
                    c-26-10.4-56.5-15.1-75.2-15.1c-1.1,0-2.2,0-3.3,0c15.8,14.4,25.3,34.6,26,56.4l0,0.1V246.5z M256.5,256.5H0v-49
                    c0-20.3,17.1-37.9,49.4-50.8c29.1-11.7,60.7-15.8,78.9-15.8s49.8,4.1,78.9,15.8c32.3,12.9,49.4,30.5,49.4,50.8V256.5z M10,246.5
                    h236.5v-39c0-21.2-27-35.1-43.1-41.6c-26-10.4-56.5-15.1-75.2-15.1c-18.7,0-49.1,4.7-75.2,15.1C37,172.4,10,186.3,10,207.5V246.5
                    z M269.1,115.6h-0.5c-31.5-0.1-57.2-25.9-57.4-57.3c-0.1-15.4,5.9-29.9,16.7-40.8c10.8-10.9,25.3-17,40.7-17c0.1,0,0.2,0,0.3,0
                    c31.6,0,57.5,25.7,57.6,57.3C326.6,89.6,300.9,115.5,269.1,115.6L269.1,115.6z M268.9,10.5c-0.1,0-0.1,0-0.2,0
                    c-26.2,0.1-47.5,21.6-47.4,47.8c0.1,26,21.4,47.3,47.4,47.4h0.4c26.2-0.1,47.5-21.6,47.4-47.8C316.4,31.7,295.1,10.5,268.9,10.5z
                    M128.3,115.6h-0.5c-31.5-0.1-57.2-25.9-57.4-57.3c-0.1-15.4,5.9-29.9,16.7-40.8c10.8-10.9,25.3-17,40.7-17c0.1,0,0.2,0,0.3,0
                    c31.6,0,57.5,25.7,57.6,57.3C185.8,89.6,160,115.5,128.3,115.6L128.3,115.6z M128,10.5c-0.1,0-0.1,0-0.2,0
                    C101.6,10.6,80.3,32,80.4,58.3c0.1,26,21.4,47.3,47.4,47.4h0.4c26.2-0.1,47.5-21.6,47.4-47.8C175.5,31.7,154.2,10.5,128,10.5z" fill="#22abc5"/>
                </g>
              </g>
            </g>
            </svg>

          <span>Utilisateurs</span></router-link></li>
          <li><router-link class="menu-item" to="/my-account">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="35.835" viewBox="0 0 33.899 35.835">
            <g id="user-symbol-of-thin-outline" transform="translate(-20.85 0.5)">
              <g id="Groupe_3" data-name="Groupe 3" transform="translate(21.35)">
                <g id="Groupe_1" data-name="Groupe 1" transform="translate(7.382)">
                  <path id="Tracé_1" data-name="Tracé 1" d="M193.219,18.138a9.069,9.069,0,1,1,9.074-9.069A9.078,9.078,0,0,1,193.219,18.138Zm0-17.24a8.174,8.174,0,1,0,8.171,8.171A8.182,8.182,0,0,0,193.219.9Z" transform="translate(-184.15)" fill="#22abc5" stroke="#22abc5" stroke-width="1"/>
                </g>
                <g id="Groupe_2" data-name="Groupe 2" transform="translate(0 21.127)">
                  <path id="Tracé_2" data-name="Tracé 2" d="M54.248,479.608H21.377l-.027-5.514a8.257,8.257,0,0,1,1.823-5.21,8.431,8.431,0,0,1,4.571-2.916l.05-.014h.054l19.975-.054.059.018a8.784,8.784,0,0,1,4.507,3,8.351,8.351,0,0,1,1.855,5.174l0,5.519Zm-31.978-.893h31.08v-4.621a7.453,7.453,0,0,0-1.66-4.616A7.917,7.917,0,0,0,47.7,466.8l-19.8.054a7.515,7.515,0,0,0-4.031,2.589,7.365,7.365,0,0,0-1.628,4.648Z" transform="translate(-21.35 -465.9)" fill="#22abc5" stroke="#22abc5" stroke-width="1"/>
                </g>
              </g>
            </g>
          </svg>

          <span>Mon compte</span></router-link></li>
          <li><a @click="logout" v-if="isLoggedIn()" style="cusror:pointer">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="35.835"  viewBox="0 0 313.18 274">
              <g id="Layer_2" data-name="Layer 2">
                <g id="Capa_1" data-name="Capa 1">
                  <path id="Icon_open-account-logout" data-name="Icon open-account-logout" d="M195.74,0v39.1H39.15V234.9H195.74V274H0V0Zm39.14,78.29L313.18,137l-78.3,58.71v-39.1H78.3V117.51H234.88Z" fill="#22abc5"/>
                </g>
              </g>
            </svg>
            <span >Déconnexion</span></a></li>
        </ul>
      </nav>
    </header>

    <div class="content">
      <router-view></router-view>
    </div>
  
  </div>
</template>
<script>
// import navbar from "./components/Wiin/Navbar";
import { mapGetters, mapMutations,mapActions } from "vuex"
import { isLoggedIn } from './utils/auth'
import { logoutUser } from './utils/auth'

export default {
  name: "App",
  data(){
    return {
      CurrentRole: null
    }
  },
  components: {
    // navbar,
  },
  methods: {
    ...mapActions(["whoami","deleteProjectFilter","getProjectCosts","getUserEmails"]),

    logout() {
      logoutUser()
      this.deleteProjectFilter({project_id: localStorage.getItem("project_id")}).then(res => {
        localStorage.clear();
        this.$router.push('/user/login')
      })
    },
    isLoggedIn() {
      return isLoggedIn()
    },

    Whoami(){
      this.whoami().then(res => {
        this.CurrentRole = (this.CurrentUser[0].role == 1) ? "User" : "Admin"
        localStorage.setItem("Role", (this.CurrentUser[0].role == 1) ? "User" : "Admin")
      })
    },

    async handleExternalLogin(type) {
			this.$loading(true)
			try {
				this.whoami().then(res => {
          this.getUserEmails({id: '1122'}).then(() => {
            if(type!=null){
              this.$loading(false);
              this.getProjectCosts({project_id: this.project_id}).then(() => {
                this.$router.push('/Comparateur-ancien')
              })
            }else{
              this.$loading(false);
              this.$router.push('/Comparateur')
            }
          })
        })
			}catch (err) {
				this.$loading(false);
          alert(`Error: ${err}`)
      }
		},

    decryptPassword(param) {
			var res = param.split(",");
			var decrypt =""
			for(var i=0; i<res.length; i++) {
				decrypt += String.fromCharCode(1990 - parseInt(res[i]))
			}
			return decrypt
		}

  },
  computed: {
    ...mapGetters(["CurrentUser","RolesCurrentUser"]),
    login(){
          return this.$route.path === '/user/login'
      }
  },
  mounted(){

    // if(!this.isLoggedIn()) {
      if(Object.keys(this.$route.query).length > 0){
        if(this.$route.query.redirect != undefined) {
          const url = new URL(`https://pro.immo-wiin.com${this.$route.query.redirect}`);
          // Access the query parameters using url.searchParams
          let userId = url.searchParams.get('a');
          let clientFullname = url.searchParams.get('d');
          let token = url.searchParams.get('tk');
          let tkimmo = url.searchParams.get('tkimmo');
          let project_id = url.searchParams.get('pid');
          let EmpEmail = url.searchParams.get('eemp');
          let EmpPhone = url.searchParams.get('eph');
          let CurrentIndexProjet = url.searchParams.get('cpi');

          let type = null;

          if(url.searchParams.get('type') != undefined){
            type = url.searchParams.get('type')
          }

          this.project_id = project_id
          this.token = token
          
          localStorage.setItem("userId",userId)
          localStorage.setItem("clientFullname",clientFullname)
          localStorage.setItem("EmpEmail",EmpEmail)
          localStorage.setItem("EmpPhone",EmpPhone)
          localStorage.setItem("EmpToken",this.token)
          localStorage.setItem("CurrentIndexProjet", CurrentIndexProjet)
          if(tkimmo) {
            localStorage.setItem('authToken', tkimmo)
            localStorage.setItem("project_id", this.project_id)
            this.handleExternalLogin(type)
          }
        }else {
          let userId = this.$route.query.a
          let clientFullname = this.$route.query.d
          let tkimmo = this.$route.query.tkimmo
          let project_id = this.$route.query.pid
          let EmpEmail = this.$route.query.eemp
          let EmpPhone = this.$route.query.eph
          let token = this.$route.query.tk
          let CurrentIndexProjet = this.$route.query.cpi
          
          this.token = token
          this.project_id = project_id

          let type = null;

          if(this.$route.query.type != undefined){
            type = this.$route.query.type
          }
          
          localStorage.setItem("userId",userId)
          localStorage.setItem("clientFullname",clientFullname)
          localStorage.setItem("EmpEmail",EmpEmail)
          localStorage.setItem("EmpPhone",EmpPhone)
          localStorage.setItem("EmpToken",this.token)
          localStorage.setItem("CurrentIndexProjet", CurrentIndexProjet)
          if(tkimmo) {
            localStorage.setItem('authToken', tkimmo)
            localStorage.setItem("project_id", this.project_id)
            this.handleExternalLogin(type)
          }
        }
      }else {
        if(this.isLoggedIn()) {
          this.Whoami()
        }
      }

    // if(this.isLoggedIn()) {
    //   this.Whoami()
    // }
  },
  watch: {
    
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped lang="scss">
@font-face {
  font-family: Metropolis;
  src: url("../public/fonts/Metropolis-Regular.otf");
}

@font-face {
  font-family: Metropolis-Bold;
  src: url("../public/fonts/Metropolis-Bold.otf");
}

@font-face {
  font-family: Seoge UI;
  src: url("../public/fonts/Segoe UI Semibold 600.ttf");
}

@font-face {
  font-family: Seoge UI-Bold;
  src: url("../public/fonts/Segoe UI Gras 700.ttf");
}

@font-face {
  font-family: Seoge UI-400;
  src: url("../public/fonts/Segoe UI 400.ttf");
}




#app {
  font-family: Metropolis;
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #fff;
  -webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
  .icon {
    text-align: center;
    .img {
      width: 130px;
    }
  }
  .logout {
    text-align: right;
    margin-bottom: 50px;
    margin-right: 4%;
    .btn {
      outline: 0;
      border: none;
      cursor: pointer;
      &:hover {
        color: #ff8c00;
      }
    }
  }
  .block {
    background-color: #068596ba;
    width: 100%;
    .menu {
      width: 25%;
      position: absolute;
    }
    .content {
      width: 72%;
      padding: 1%;
      margin-left: 25%;
      border: 1px solid #e5e5e5;
      background-color: white;
      border-radius: 3px;
      box-sizing: border-box;
      position: relative;
      top: -30px;
      margin-bottom: 10px;
      min-height: 450px;
    }
  }
}
@media screen and (max-width: 1024px) {
#app {
  .block{
    .menu{
      width: 8%;
    }
    .content{
      width: 90%;
      margin-left: 8%;
    }
  }
}
}
@media screen and (max-width: 768px) {
#app {
  .block{
    .menu{
      width: 12%;
    }
    .content{
      width: 85%;
      margin-left: 12%;
    }
  }
}
}
</style>
<style scoped lang="scss">

  $secondary:#FF8C00;

  nav a.router-link-active {
    color: #FF8C00;
    svg {
      path {
        fill: #FF8C00;
        stroke: #FF8C00;
      }
    }
}

  body {
    font-family: Metropolis;
    background-color: #FFFFFF;
  }
  header{
    display: flex;
    align-items: center;
    box-shadow: 0px 3px 5px #8888;
    height: 130px;
    padding: 0 2% 0;
    .logo-holder {
      flex: 0.66;
      display: flex;
      padding-left: 15px;
      img {
        width: 186px;
        // height: 27px;
      }
      margin-right: 30px;

    }
    nav {
      flex: 1;
      font-family: Metropolis;
      ul {
        text-align: end;
        list-style: none;
        margin: 0;
        padding: 0;
        li {
          display: inline-block;
          font-size: 0.8em;
          a {
            color: #22ABC5;
            padding: 15px 20px; 
            vertical-align: top;
            text-align: center;
            display: inline-block;
            text-decoration: none;
            span {
              display: block;
              font-weight: bold;
              font-size: 13px;
            }
            svg {
              font-size: 2em;
            }
            a:hover {
              color: #FF8C00 !important;
            
            }
          }
          &.active {
            a {
              color: $secondary;
              font-weight: lighter;
            }
          }
        }
      }
    }
    .content {
      margin: 20px !important;
    }
  }
  @media screen and (max-width: 768px) {
    header {
      display: block;
      .logo-holder {
        flex: 1;
        display: flex;
        padding-left: 15px;
        margin-right: 30px;
        padding-top: 15px;
      }
    }
  }
  
  
</style>
